/**
 * Generates action types with namespaces
 */
export default (namespace: string) => (type: string): string =>
  `${namespace}/${type}`
